'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var regexPlaceholders = /\{(\d+)\}/g;

var Translator = exports.Translator = function () {
  function Translator(data) {
    _classCallCheck(this, Translator);

    this.language = data.language;
    this.dateTimeFormat = data.dateTimeFormat;
    this.dateFormat = data.dateFormat;
    this.timeFormat = data.timeFormat;
    this.dayMonthFormat = data.dayMonthFormat;
    this.expressions = data.expressions;
  }

  _createClass(Translator, [{
    key: 'translate',
    value: function translate(expression) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var translatedExpression = this.expressions[expression];

      if (!translatedExpression) {
        translatedExpression = expression;
      }

      if (!translatedExpression) {
        return '';
      }

      return translatedExpression.replace(regexPlaceholders, function (match, number) {
        var argIndex = parseInt(number, 10);
        return args[argIndex];
      });
    }
  }, {
    key: 'translateFirstUpper',
    value: function translateFirstUpper(expression) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var translatedExpression = this.translate.apply(this, [expression].concat(args));

      if (translatedExpression.length === 0) {
        return translatedExpression;
      }

      return translatedExpression.substr(0, 1).toUpperCase() + translatedExpression.substr(1).toLowerCase();
    }
  }]);

  return Translator;
}();

var translator = void 0;

var init = exports.init = function init(data) {
  translator = new Translator(data);
};

var translate = exports.translate = function translate(expression) {
  var _translator;

  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return (_translator = translator).translate.apply(_translator, [expression].concat(args));
};

var translateFirstUpper = exports.translateFirstUpper = function translateFirstUpper(expression) {
  var _translator2;

  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return (_translator2 = translator).translateFirstUpper.apply(_translator2, [expression].concat(args));
};

var getLanguage = exports.getLanguage = function getLanguage() {
  return translator.language;
};

var getDateTimeFormat = exports.getDateTimeFormat = function getDateTimeFormat() {
  return translator.dateTimeFormat;
};

var getDateFormat = exports.getDateFormat = function getDateFormat() {
  return translator.dateFormat;
};

var getTimeFormat = exports.getTimeFormat = function getTimeFormat() {
  return translator.timeFormat;
};

var getDayMonthFormat = exports.getDayMonthFormat = function getDayMonthFormat() {
  return translator.dayMonthFormat;
};